import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "App-Loader-Loading" }
const _hoisted_2 = { class: "App-Loader-Empty" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "el-fade-in-linear" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "loading")
        ], 512), [
          [_vShow, _ctx.loading]
        ])
      ]),
      _: 3
    }),
    _createVNode(_Transition, { name: "el-fade-in-linear" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "empty")
        ], 512), [
          [_vShow, !_ctx.loading && (!_ctx.resources || _ctx.resources.length === 0)]
        ])
      ]),
      _: 3
    })
  ]))
}